import { FC } from 'react';

import { IconClose } from '@purpur/library/icon/close';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_TEST_ID } from '../constants';
import { RemoveButton } from '../entries/entries.styles';

type Props = {
    onRemove?: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
};

export const RemoveAction: FC<Props> = ({ isLoading, isDisabled, onRemove }) => {
    const { t } = useTranslations();

    if (!onRemove) {
        return null;
    }

    return (
        <RemoveButton
            variant="text"
            onClick={onRemove}
            loading={isLoading}
            disabled={isDisabled}
            data-test={ORDER_CART_TEST_ID.ENTRY_ACTION}
        >
            <IconClose size="xs" />
            {t['order_cart.entry_insurance.remove_btn']}
        </RemoveButton>
    );
};
